import { validate as uuidValidate } from 'uuid';

/**
 * True when `value` looks like a real organization UUID. The Restate queries
 * extract an "org" from `target_service_key`, but system/infrastructure jobs
 * (cron, locks, dead-letter, system-scoped sagas, etc.) don't begin with an
 * org id, so their extracted value isn't a valid UUID. We use this to split
 * those out of the per-organization tables.
 */
export const isOrgUuid = (value: string): boolean => uuidValidate(value);
